import React, {Component} from 'react'
import './assets-static/stylesheets/theme.css';
import {connect} from "react-redux";
import {loadApplicationData, saveApplicationData} from "./actions/ApplicationAction";
        import EQ_1_1 from "./components/EQ-1.1";
        import EQ_2_2_6 from "./components/EQ-2.2.6";
        import EQ_2_3 from "./components/EQ-2.3";
        import EQ_2_3_1 from "./components/EQ-2.3.1";
        import EQ_2_3_2 from "./components/EQ-2.3.2";
        import EQ_2_3_3 from "./components/EQ-2.3.3";
        import EQ_2_3_4 from "./components/EQ-2.3.4";
        import EQ_2_3_5 from "./components/EQ-2.3.5";
        import EQ_3_1 from "./components/EQ-3.1";
        import EQ_3_1_1 from "./components/EQ-3.1.1";
        import EQ_3_1_2 from "./components/EQ-3.1.2";
        import EQ_2_1 from "./components/EQ-2.1";
        import EQ_3_1_3 from "./components/EQ-3.1.3";
        import EQ_3_1_4 from "./components/EQ-3.1.4";
        import EQ_3_1_5 from "./components/EQ-3.1.5";
        import EQ_3_2 from "./components/EQ-3.2";
        import EQ_3_2_1 from "./components/EQ-3.2.1";
        import EQ_3_2_2 from "./components/EQ-3.2.2";
        import EQ_3_2_3 from "./components/EQ-3.2.3";
        import EQ_3_2_4 from "./components/EQ-3.2.4";
        import EQ_3_2_5 from "./components/EQ-3.2.5";
        import EQ_3_2_6 from "./components/EQ-3.2.6";
        import EQ_2_1_1 from "./components/EQ-2.1.1";
        import EQ_3_3 from "./components/EQ-3.3";
        import EQ_3_3_1 from "./components/EQ-3.3.1";
        import EQ_3_3_2 from "./components/EQ-3.3.2";
        import EQ_3_3_3 from "./components/EQ-3.3.3";
        import EQ_3_3_4 from "./components/EQ-3.3.4";
        import EQ_3_3_5 from "./components/EQ-3.3.5";
        import EQ_4_1 from "./components/EQ-4.1";
        import EQ_4_1_1 from "./components/EQ-4.1.1";
        import EQ_4_1_2 from "./components/EQ-4.1.2";
        import EQ_4_1_3 from "./components/EQ-4.1.3";
        import EQ_2_2 from "./components/EQ-2.2";
        import EQ_4_2 from "./components/EQ-4.2";
        import EQ_4_2_1 from "./components/EQ-4.2.1";
        import EQ_4_2_2 from "./components/EQ-4.2.2";
        import EQ_4_2_3 from "./components/EQ-4.2.3";
        import EQ_4_2_4 from "./components/EQ-4.2.4";
        import EQ_4_2_5 from "./components/EQ-4.2.5";
        import EQ_4_2_6 from "./components/EQ-4.2.6";
        import EQ_5_1 from "./components/EQ-5.1";
        import EQ_5_1_1 from "./components/EQ-5.1.1";
        import EQ_5_1_2 from "./components/EQ-5.1.2";
        import EQ_2_2_1 from "./components/EQ-2.2.1";
        import EQ_5_1_3 from "./components/EQ-5.1.3";
        import EQ_5_2 from "./components/EQ-5.2";
        import EQ_5_2_1 from "./components/EQ-5.2.1";
        import EQ_5_2_2 from "./components/EQ-5.2.2";
        import EQ_5_2_3 from "./components/EQ-5.2.3";
        import EQ_5_2_4 from "./components/EQ-5.2.4";
        import EQ_5_2_5 from "./components/EQ-5.2.5";
        import EQ_6_1 from "./components/EQ-6.1";
        import EQ_6_1_1 from "./components/EQ-6.1.1";
        import EQ_6_1_2 from "./components/EQ-6.1.2";
        import EQ_2_2_2 from "./components/EQ-2.2.2";
        import EQ_6_2 from "./components/EQ-6.2";
        import EQ_6_2_1 from "./components/EQ-6.2.1";
        import EQ_6_2_2 from "./components/EQ-6.2.2";
        import EQ_6_2_3 from "./components/EQ-6.2.3";
        import EQ_6_2_4 from "./components/EQ-6.2.4";
        import EQ_2_2_3 from "./components/EQ-2.2.3";
        import EQ_2_2_4 from "./components/EQ-2.2.4";
        import EQ_2_2_5 from "./components/EQ-2.2.5";
    import { BrowserRouter, Route, Switch } from 'react-router-dom';

class EQ extends Component {
constructor(props) {
super(props);
}

render() {
return (
<div>
    {this.props.application != undefined && this.props.application.applicationData != undefined &&
        <BrowserRouter>
            <Switch>
                                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-1.1">
                            <EQ_1_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.2.6">
                            <EQ_2_2_6 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.3">
                            <EQ_2_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.3.1">
                            <EQ_2_3_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.3.2">
                            <EQ_2_3_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.3.3">
                            <EQ_2_3_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.3.4">
                            <EQ_2_3_4 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.3.5">
                            <EQ_2_3_5 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.1">
                            <EQ_3_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.1.1">
                            <EQ_3_1_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.1.2">
                            <EQ_3_1_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.1">
                            <EQ_2_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.1.3">
                            <EQ_3_1_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.1.4">
                            <EQ_3_1_4 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.1.5">
                            <EQ_3_1_5 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.2">
                            <EQ_3_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.2.1">
                            <EQ_3_2_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.2.2">
                            <EQ_3_2_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.2.3">
                            <EQ_3_2_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.2.4">
                            <EQ_3_2_4 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.2.5">
                            <EQ_3_2_5 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.2.6">
                            <EQ_3_2_6 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.1.1">
                            <EQ_2_1_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.3">
                            <EQ_3_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.3.1">
                            <EQ_3_3_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.3.2">
                            <EQ_3_3_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.3.3">
                            <EQ_3_3_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.3.4">
                            <EQ_3_3_4 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-3.3.5">
                            <EQ_3_3_5 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.1">
                            <EQ_4_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.1.1">
                            <EQ_4_1_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.1.2">
                            <EQ_4_1_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.1.3">
                            <EQ_4_1_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.2">
                            <EQ_2_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.2">
                            <EQ_4_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.2.1">
                            <EQ_4_2_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.2.2">
                            <EQ_4_2_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.2.3">
                            <EQ_4_2_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.2.4">
                            <EQ_4_2_4 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.2.5">
                            <EQ_4_2_5 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-4.2.6">
                            <EQ_4_2_6 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.1">
                            <EQ_5_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.1.1">
                            <EQ_5_1_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.1.2">
                            <EQ_5_1_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.2.1">
                            <EQ_2_2_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.1.3">
                            <EQ_5_1_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.2">
                            <EQ_5_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.2.1">
                            <EQ_5_2_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.2.2">
                            <EQ_5_2_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.2.3">
                            <EQ_5_2_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.2.4">
                            <EQ_5_2_4 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-5.2.5">
                            <EQ_5_2_5 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-6.1">
                            <EQ_6_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-6.1.1">
                            <EQ_6_1_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-6.1.2">
                            <EQ_6_1_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.2.2">
                            <EQ_2_2_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-6.2">
                            <EQ_6_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-6.2.1">
                            <EQ_6_2_1 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-6.2.2">
                            <EQ_6_2_2 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-6.2.3">
                            <EQ_6_2_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-6.2.4">
                            <EQ_6_2_4 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.2.3">
                            <EQ_2_2_3 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.2.4">
                            <EQ_2_2_4 />
                        </Route>
                                            <Route path="/fbgc/interactions/eq/users/0/applications/0/pages/EQ-2.2.5">
                            <EQ_2_2_5 />
                        </Route>
                                                </Switch>
        </BrowserRouter>
    }
</div>)
}
}

const mapDispatchToProps = (dispatch) => {
loadApplicationData("fbgc").then((data) => {
return {
application: dispatch(data).payload
}
})
return dispatch(saveApplicationData({}))
};

const mapStateToProps = state => {
return {
application: state.application
}
};

export default connect(mapStateToProps, mapDispatchToProps)(EQ)
